export default __webpack_public_path__ + "static/media/a9.ade18cd0.png";